import React from 'react';
import '../site/site.css';
import SiteNav from '../site/SiteNav';
import SiteFooter from '../site/SiteFooter';

function About() {
  return (
    <div className="qs ruled">
      <SiteNav active="about" />
      <main className="qs-about">
        <header className="qs-about__head">
          <div className="kicker">About</div>
          <h1>A different way to simulate quantum systems.</h1>
          <p>Qutron is a research simulator. Rather than tracking a wavefunction, it builds quantum-style correlations out of classical parts and the timing between them.</p>
        </header>

        <section className="qs-method" aria-labelledby="method-title">
          <div className="qs-method__text">
            <div className="kicker" style={{ fontSize: 12 }}>The method</div>
            <h2 id="method-title">One pair of qubytes, one measurement</h2>
            <p>Each qubyte is rotated by its measurement setting. The pair then signal each other at the same moment; which signal arrives first is never chosen by anyone, and it plays the role of the hidden variable. Each side reads out ±1, and the correlations across many runs are what the simulator reports.</p>
            <p>In software terms, it’s a race condition used on purpose. Two signals racing each other, which would normally count as a bug, become the source of the hidden variable: nothing in the program decides which one wins.</p>
          </div>
          <figure className="qs-method__fig" style={{ margin: 0 }}>
            <svg viewBox="0 0 820 300" width="100%" role="img" aria-label="Timing diagram: qubyte A and qubyte B each rotate, then signal each other at the same moment; the first arrival sets the hidden variable; each side reads out plus or minus one">
              <g fontFamily="IBM Plex Mono, monospace" fontSize="13">
                <text x="0" y="76" fill="#141A26">qubyte A</text>
                <text x="0" y="216" fill="#141A26">qubyte B</text>
                <line x1="90" y1="80" x2="810" y2="80" stroke="#141A26" strokeWidth="1.5" />
                <line x1="90" y1="220" x2="810" y2="220" stroke="#141A26" strokeWidth="1.5" />
                <rect x="110" y="64" width="120" height="32" fill="#FFFFFF" stroke="#141A26" /><text x="170" y="85" textAnchor="middle" fill="#141A26">rotate</text>
                <rect x="110" y="204" width="120" height="32" fill="#FFFFFF" stroke="#141A26" /><text x="170" y="225" textAnchor="middle" fill="#141A26">rotate</text>
                <line x1="270" y1="40" x2="270" y2="262" stroke="#8A93A6" strokeDasharray="2 4" />
                <text x="270" y="28" textAnchor="middle" fill="#4A5366">signal both at once</text>
                <line x1="270" y1="80" x2="470" y2="220" stroke="#2A55C9" strokeWidth="3" />
                <circle cx="470" cy="220" r="6" fill="#2A55C9" />
                <line x1="270" y1="220" x2="580" y2="80" stroke="#141A26" strokeWidth="1.5" strokeDasharray="6 5" />
                <circle cx="580" cy="80" r="6" fill="#FFFFFF" stroke="#141A26" strokeWidth="1.5" />
                <line x1="470" y1="268" x2="580" y2="268" stroke="#2A55C9" /><line x1="470" y1="260" x2="470" y2="276" stroke="#2A55C9" /><line x1="580" y1="260" x2="580" y2="276" stroke="#2A55C9" />
                <text x="525" y="294" textAnchor="middle" fill="#2A55C9">arrival order = hidden variable</text>
                <rect x="660" y="64" width="110" height="32" fill="#2A55C9" /><text x="715" y="85" textAnchor="middle" fill="#FFFFFF">read ±1</text>
                <rect x="660" y="204" width="110" height="32" fill="#2A55C9" /><text x="715" y="225" textAnchor="middle" fill="#FFFFFF">read ±1</text>
              </g>
            </svg>
            <figcaption>Schematic, not to scale.</figcaption>
          </figure>
        </section>

        <div className="qs-cols">
          <section className="qs-col">
            <div className="kicker">Where it came from</div>
            <p>Qutron grew out of a random number generator built on asynchronous timing, first on Arduino hardware and later as a containerized service. That prototype produced correlations strong enough to violate Bell’s inequality, which is what started the simulator.</p>
          </section>
          <section className="qs-col">
            <div className="kicker">Where it stands</div>
            <p>Qutron is an early-stage research project. The lab is open for experiments; broader results are still being tested and aren’t published yet.</p>
            <a className="qs-btn" href="https://lab.qutron.co">Try it in the lab →</a>
          </section>
        </div>
      </main>
      <SiteFooter />
    </div>
  );
}

export default About;
